export default __webpack_public_path__ + "static/media/Group9272.d1a714f8.svg";